"use strict";

module.exports = {
	List: require('./Brokers'),
	View: require('./BrokerDetails'),
	AddEdit: require('./BrokerAddEdit'),
	AddAgent: require('./BrokerAddAgent')
};